import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { notificationsService } from '../api/notifications.service';
import { NOTIFICATION_KEYS } from './queryKeys';
import type { NotificationsQueryParams } from '../types';

/** User-global — spans every organization the user belongs to, not just the active one. */
export function useNotifications(params: NotificationsQueryParams = {}) {
  return useQuery({
    queryKey: NOTIFICATION_KEYS.list(params),
    queryFn: ({ signal }) => notificationsService.getNotifications(params, signal),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
